import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/pages/auth/services/authentication.service';
import { AuthService } from '../../../abstraction/auth.service';
import { EditInformationComponent } from './edit-information/edit-information.component';
import { EditNumberDialogComponent } from './edit-number-dialog/edit-number-dialog.component';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.scss'],
})
export class PersonalInformationComponent implements OnInit {
  constructor(
    public auth: AuthService,
    public authentication: AuthenticationService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {}

  editInfo() {
    this.dialog
      .open(EditInformationComponent, {
        panelClass: 'modal-container',
        data: 2,
      })
      .afterClosed()
      .subscribe((res) => {
        setTimeout(() => {
          if (res) {
            this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'Datos confirmados',
                content: `Tus datos personales fueron confirmados con éxito.`,
              },
            });
          }
        }, 1000);
      });
  }

  openChangeNumberComponent() {
    this.dialog
      .open(EditNumberDialogComponent, {
        panelClass: 'modal-container',
      })
      .afterClosed()
      .subscribe((res) => {
        setTimeout(() => {
          if (res) {
            this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'Datos confirmados',
                content: `Tu télefono ha sido modificado.`,
              },
            });
          }
        }, 1000);
      });
  }
}
